import { createEntityAdapter } from '@ngrx/entity';
import { SocieteTerritoireUserEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocieteTerritoireUserEntityState>;

export const adapter = createEntityAdapter<SocieteTerritoireUserEntityState>({
  selectId: o => o.idSocieteTerritoireUser
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societeTerritoireUserFeatureKey = 'societeTerritoireUser';
